import { blueGrey } from '@mui/material/colors';
import type { Components, Theme } from '@mui/material/styles';

const MuiCard: Components<Theme>['MuiCard'] = {
  styleOverrides: {
    /**
     * Корневые стили карточки
     * @param props Пропсы
     * @param props.theme Тема
     */
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderL,
      borderWidth: 1,
      borderColor: blueGrey[50],
      borderStyle: 'solid',
      boxShadow: theme.shadows[0],
      // ВНИМАНИЕ: паддинг обязан оставаться безусловным объявлением, без
      // медиазапроса. Медиазапрос из темы перебивает безусловное `p: 0` в sx
      // консьюмера (emotion выносит @media после базовых свойств), и попытка
      // сделать здесь `{xs: 12, sm: 16}` вернула 16px паддинга всем карточкам,
      // которые его снимают: у карточек актёров появлялась белая рамка, имя
      // ложилось на неё, под фото шла полоса. Телефонную плотность добираем
      // там, где она нужна (паддинг аккордеона в accordion.ts), а не здесь.
      padding: '16px'
    })
  }
};

export const card = {
  MuiCard
};
